import { render } from "./SideNav.vue?vue&type=template&id=211d554b&ts=true"
import script from "./SideNav.vue?vue&type=script&lang=ts"
export * from "./SideNav.vue?vue&type=script&lang=ts"

import "./SideNav.vue?vue&type=style&index=0&id=211d554b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__